export default __webpack_public_path__ + "static/media/DeleteIcon.579284a2.svg";